import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { TrackingParametersComponent } from '@app/unauthenticated/trackingParameters.component';

@Component({
  selector: 'app-currencies',
  templateUrl: './currencies.component.html',
  styleUrls: ['./currencies.component.scss'],
})
export class CurrenciesComponent extends TrackingParametersComponent {
  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    super(platformId);
  }
}
